import React, { useEffect } from "react";
import { Table  } from 'antd';
import Card from "components/card";
import CrudOption from "components/dropdown/crudoption";
import { connect } from "react-redux";
import HolidayForm from "./HolidayForm";
import { handleTableChange } from "utils/index";
import { 
	getHolidayList, 
	doHolidayDelete,
	doHolidayReset,
} from "../../../../../redux/holiday/holidayState";


const PayslipTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {

  	const columns = [
		{
	        title: `Payroll Cut-off`,
	        dataIndex: 'hol_name',
	        key: 'hol_name',
	        width: '58%',
	        render:(hol_name) => <span>{hol_name}</span> 
	    },
	    {
	        title: '',
	        dataIndex: 'hol_id',
	        key: 'hol_id',
	        width: '12%',
	        render:(_, record) => <CrudOption 
									baseRoute="/console/holidays" 
									recordId={record?.hol_id} 
									deleteHandler={doDelete} 
									allowEdit={false}
									viewMode="modal"
									title="Edit Holiday"
									closeHandler={doRecordReset}
									viewHandler={(recordId, doRecordReset ) => (
										<HolidayForm 
											recordId={recordId} 
											mode="edit" 
											onCancel={doRecordReset} 
										/>
									)}
								/>
	    },
    ];
    
	// useEffect(() => {
	// 	doSearch({paginate: pagination.per_page});
	// }, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.hol_id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
					onChange={handleTableChange(doSearch, filters)}                	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.holiday.holidayList?.items,
	pagination: state.holiday.holidayList?.pagination,
	filters: state.holiday.holidayList?.filters,
	requesting: state.holiday.holidayList?.requesting,
	error: state.holiday.holidayList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getHolidayList(filters)),
	doDelete: (id) => dispatch(doHolidayDelete(id)),
	doRecordReset: () => dispatch(doHolidayReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayslipTable);
